export { useShallowSelector } from '../../../hooks/useShallowSelector';

export const componentSelector = (state) => ({
  activeForgivenessId: state.activeIds.forgivenessId,
  advancesById: state.entities.advances.byId,
  loanForgivenessById: state.entities.loanForgiveness.byId,
});
